import fetchAPI from "../../../utils/fetchAPI";
import fetchAPIV2 from "../../../utils/fetchAPIV2";

const useUploadFile = (props) => {
  const { newCustumers, handleToast, setLoading, refreshData } = props;

  const submitFile = (file) => {
    return new Promise(async (resolve, reject) => {
      try {
        if (file && file.type === 'text/csv') {
          const service = `v1/mx/admin/massive_load/${ newCustumers ? 'new' : 'upgrade'}/bmax`;
          const customParams = new FormData();
          customParams.append('file', file);
          setLoading(true);
          const { status, data } = await fetchAPIV2({
            customParams,
            service,
            protocol: 'POST',
            noContentType: true,
            callbackSuccess: (status, responseData) => {
              setLoading(false);
              console.log(status)
              console.log(responseData)
              handleToast({
                open: true,
                message: `Se procesaran ${responseData.meta.lenght} registros, favor de esperar.`,
                title: 'Carga realizada exitosamente',
                type: 'success',
              });
              if (refreshData) refreshData();
              resolve(true);
            },
            callbackError: (error) => {
              console.log(error)
              console.log(error.status)
              console.log(error.data)
              setLoading(false);
              handleToast({
                open: true,
                message: error.data.message2,
                title: error.data.message1,
                type: 'error',
              });
              resolve(true);
            },
          });
        } else {
          setLoading(false);
          handleToast({
            open: true,
            message: 'Subir un archivo con el formato csv.',
            title: 'Tipo de archivo inválido.',
            type: 'error',
          });
          resolve(true);
        }

      } catch (error) {
        reject(error);
      }
    });
  }

  return {
    submitFile,
  };
};

export default useUploadFile;
